// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Tx-z","tooltipWrapper":"Ux-z","icon":"Vx-z","tooltip":"Wx-z","content":"Xx-z"};